<script>
import VectorLayer from 'ol/layer/Vector'
import GeoJSON from 'ol/format/GeoJSON'
import VectorSource from 'ol/source/Vector'
import Select from 'ol/interaction/Select'
import parseStyle from '../ol-map/utils/style'
import { Feature } from 'ol';
import { Point } from 'ol/geom';
import { Style, Icon } from 'ol/style';
function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

// 图形样式
const defaultEffect = {
  icon: {
    anchor: [0.5, 0.5],
    src: require(`@/assets/images/certified/${Math.floor(Math.random() * 5) + 1}.png`),
    offset: [0, 0],
    scale: 0.6
  }
}

// 选中样式
const selectedEffect = {
  icon: {
    anchor: [0.5, 0.5],
    src: require('@/assets/images/certified/active.png'),
    offset: [0, 0],
    scale: 0.6
  }
}

// 地图实例
let olMap = null

export default {
  name: 'ol-geom-point',

  inject: ['getMap'],
  provide() {
    return {
      getLayer: this.getLayer,
    };
  },

  render() {
    return null
  },

  props: {
    // 图层名称
    name: {
      type: String,
      default: ''
    },

    // 图层类型
    type: {
      type: String,
      default: ''
    },

    // 是否可见
    visible: {
      type: Boolean,
      default: true
    },

    // 透明度（0~1）
    opacity: {
      type: Number,
      default: 1
    },

    // 层级
    zIndex: {
      type: Number,
      default: undefined
    },

    features: {
      type: [Object, String],
      default: ''
    },
    coordinates: {
      type: Array,
      default() {
        return []
      }
    },

    // 图形样式
    effect: {
      type: [Object, Function],
      default() {
        return defaultEffect
      }
    },

    // 选中样式
    selected: {
      type: [Object, Function],
      default() {
        return selectedEffect
      }
    }
  },

  watch: {
    visible(visible) {
      this.vectorLayer.setVisible(visible)
    },
    coordinates(val) {
      if (val && val.length > 0) {
        const features = []
        val.forEach(coord => {
          const feature = new Feature({
            geometry: new Point([coord.lon, coord.lat]),
            ...coord,
            layerType:this.name
          });
          defaultEffect.icon.src = coord.iconUrl
          feature.setStyle(parseStyle({ ...defaultEffect, ...this.effect }));
          features.push(feature)
        })
        const vectorSource = this.vectorLayer.getSource()
        vectorSource.clear()
        vectorSource.addFeatures(features)
      } else {
        const vectorSource = this.vectorLayer.getSource()
        vectorSource.clear()
      }
    },

    zIndex(zIndex) {
      this.vectorLayer.setZIndex(zIndex)
    },

    features(newVal) {
      const vectorSource = this.vectorLayer.getSource()
      vectorSource.clear()
      if (newVal === '') {
        return
      }
      const geoJson = new GeoJSON()
      if (isString(newVal)) {
        // geojson 字符串
        const features = geoJson.readFeatures(newVal)
        // features.forEach(item => {
        //   item.setStyle(parseStyle({ ...defaultEffect, ...this.effect }))
        // })
        vectorSource.addFeatures(features)
      } else {
        const features = geoJson.readFeatures(newVal)
        // features.forEach(item => {
        //   item.setStyle(parseStyle({ ...defaultEffect, ...this.effect }))
        // })
        vectorSource.addFeatures(features)
      }
    }
  },

  data() {
    return {
      vectorLayer: null,
      select: null
    }
  },

  created() {

    this.vectorLayer = new VectorLayer({
      name: this.name,
      type: this.type,
      visible: this.visible,
      zIndex: this.zIndex,
      opacity: this.opacity,
      style: parseStyle({ ...defaultEffect, ...this.effect }),
      source: new VectorSource()
    })

    this.select = new Select({
      layers: [this.vectorLayer],
      style: parseStyle({ ...selectedEffect, ...this.selected })
    })

    this.getMap(map => {
      olMap = map
      map.on('pointermove', this.pointerMoveHandle)
      map.addLayer(this.vectorLayer)
      map.addInteraction(this.select)
    })
  },

  methods: {
    getLayer() {
      return this.vectorLayer
    },
    pointerMoveHandle(evt) {
      const pixel = evt.map.getEventPixel(evt.originalEvent)
      const feature = evt.map.forEachFeatureAtPixel(pixel, feature => {
        return feature
      })
      const element = evt.map.getTargetElement()
      if (feature === undefined || feature.getGeometry().getType() !== 'Point') {
        element.style.cursor = 'auto'
      } else {
        element.style.cursor = 'pointer'
      }
    }
  },

  beforeDestroy() {
    this.vectorLayer = null
    olMap.removeInteraction(this.select)
  }
}
</script>
